import axios from 'axios';
import { baseUrlApi } from "./../config/index";

const service = axios.create({
    baseURL: baseUrlApi, // url = base url + request url
})


export default service
